// extracted by mini-css-extract-plugin
module.exports = {"NoResultsContainer":"noresult_NoResultsContainer__2Tquc","NoResultsInner":"noresult_NoResultsInner__IGm6T"};